@if (mode === 'list') {
  <div class="flex flex-col gap-2">
    <div>
      <button
        type="button"
        class="btn-save-filters"
        [disabled]="disableSave"
        (click)="changeMode('form')"
      >
        Save New Filter View
      </button>
    </div>
    @if (filters.length > 0) {
      <div class="filters-list">
        <blaze-scroller [propagate]="false">
          @for (filter of filters; track trackByNameAndScope($index, filter)) {
            <div
              class="filter-option"
              [class.scroll-visible]="filters.length > 7"
              (click)="applyFilter(filter)"
            >
              <span
                class="text-ellipsis overflow-hidden whitespace-nowrap"
                [blazeTooltip]="filter.name"
                [matTooltipShowDelay]="500"
                >{{ filter.name }}</span
              >
              <div class="flex gap-8 items-center justify-end">
                @if (filter.scope === DatasetFilterScope.Account) {
                  <span class="public-tag"> Public </span>
                }
                @if (filter.scope === DatasetFilterScope.Private || filter.isOwnedByCurrentUser) {
                  <button type="button" class="icon-button" (click)="deleteFilter(filter, $event)">
                    <mat-icon svgIcon="icon_trash_16" />
                  </button>
                }
              </div>
            </div>
          }
        </blaze-scroller>
      </div>
    }
    <blaze-element-loading-indicator [isVisible]="showLoadingIndicator" mode="theme" />
  </div>
}

@if (mode === 'form') {
  <div class="p-4">
    <form [formGroup]="form" (ngSubmit)="saveFilter()">
      <div class="flex flex-col gap-8">
        <div class="flex gap-8">
          <input type="text" formControlName="name" class="bd-text-input" />
          <button
            type="submit"
            class="form-btn-save"
            [disabled]="form.controls['name'].hasError('required')"
          >
            Save
          </button>
        </div>
        @if (allowToCreatePublicFilters) {
          <div class="flex items-center justify-between">
            <mat-slide-toggle formControlName="public" class="bd-toggle with-theme"
              >Visible to all users</mat-slide-toggle
            >
            @if (form.value.public) {
              <span class="public-tag">Public</span>
            }
          </div>
        }
      </div>
    </form>
  </div>
}
